import { useRouter } from 'next/router';
import SiteView   from 'components/Site/View';
import SignInForm from 'components/Forms/SignIn';
import styles     from './auth-view.module.scss';

const AuthView = ({ title }) => {
	const { then } = useRouter().query;

	return (
		<SiteView>
			<div className={styles.root}>
				<SignInForm thenURL={then}/>
			</div>
		</SiteView>
	)
};

export default AuthView;